import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Alert, IconButton, TableCell, TableRow } from "@mui/material";
import { format } from 'date-fns';
import React, { useMemo } from "react";
import { formatTime } from 'src/coach/service/coach.utils';
import { ConfirmationModal } from 'src/registration/ui/components/confirmation-modal';
import { useModal } from 'src/shared/hooks/use-modal';
import TimeOffConflicts from './time-off-conflicts';


export const ScheduledTimeOffItem = ({ row,handleEdit,handleDelete,franchise,loading  }) => {
  const {isOpen:isOpenDelete, actions:deleteActions} = useModal();
  const {isOpen:isOpenConflicts, actions:conflictsActions} = useModal();
  

  const canManageTimeOffs = useMemo(() => {
    return franchise?.settings?.canManageTimeOff && row?.status === 'Pending';
  }
  ,[franchise]);
  const dateRange = `${format(
    new Date(row.startDate),
    'MM/dd/yyy',
  )} - ${format(new Date(row.endDate), 'MM/dd/yyy')}`;
  const timeRange =
  row.startTime === '00:00' && row.endTime === '23:59'
    ? 'All Day'
    : `${formatTime(row.startTime)} - ${formatTime(row.endTime)}`;
  return (
    <>
   <TableRow key={row.id}>
    <TableCell>
      <div className="tw-flex ">
            <span className="tw-mr-2">{dateRange}</span>
            {row?.conflicts.length ? (
					<span className='tw-text-blue-light tw-underline' onClick={() => conflictsActions.open()}>
						({row?.conflicts.length} Conflicts)
					</span>
				):null}
          </div></TableCell>
    <TableCell>{timeRange}

    </TableCell>
    {/* <TableCell>{row.isPaid ? 'Paid' : 'Unpaid'}</TableCell> */}
    <TableCell
          className={`${row.status === 'Approved' ? "tw-text-[#22C55E]": `${row.status === 'Rejected' ? "tw-text-[#EF4444]": ''}`}`}
        >{row.status}</TableCell>
   
				<TableCell>
           {canManageTimeOffs && (
            <>
					<IconButton onClick={() => handleEdit(row)}>
						<EditIcon />
					</IconButton>
					<IconButton onClick={() => deleteActions.open()}>
						<DeleteIcon />
					</IconButton>
          </>
          )}
				</TableCell>
	
   </TableRow>
   {isOpenDelete && (
        <ConfirmationModal
          $title="Remove time off"
          $actions={deleteActions}
          $message={
            <Alert severity='error'>
              <div className='tw-flex tw-flex-col tw-gap-4'>
          <p>
          Are you sure you want to remove scheduled time off for{' '}
          <b>{dateRange}</b> from <b>{timeRange}</b>?
          </p>
          </div>
           </Alert> 
          }
          $confirmBtnText="Remove"
          $cancelBtnText="Cancel"
          $onConfirm={()=>handleDelete(row.id)}
          $maxWidth={450}
          $loading={loading}
          $confirmBtnClass = {'tw-bg-red tw-text-white tw-border-red'}
          $cancelButtonClass={'tw-text-red tw-border-red'}
        />
      )}
      {isOpenConflicts && <TimeOffConflicts timeOff={row} conflicts={row?.conflicts || []} onClose={()=>conflictsActions.close()} showConfirm={false} />}
      </>
  );
}